module.exports = __webpack_public_path__ + "assets/img/3004.1a60eb8b.png";